export function getAllAreas(state){
    return state.soilAreas
}